import { checkHttpStatus, parseJSON, expiredToken, errorResponse } from '../../utils/response';
import { Token, UserCode, EmployeeId } from '../../utils/users';
import { encryption } from '../../utils/encryption';

export function savePIN(oldPIN, newPIN) {
    return fetch('security/SavePIN', {
        method: 'post',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            userCodeCrypt: encryption(UserCode()),
            employeeIdCrypt: encryption(EmployeeId()),
            oldPINCrypt: oldPIN,
            newPINCrypt: newPIN,
            token: Token()
        })
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return JSON.parse(response.result);
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}